import * as _ from 'underscore';

export function collectionWhere() {
    return function(list, filterConditions) {
        return _.where(list, filterConditions);
    };
}
